import { CadBoxExportFileName } from "../../tools/CadBoxExportFileName";

import {
  type JSX,
  Suspense,
  useEffect,
  useEffectEvent,
  useMemo,
  useState,
} from "react";

import { Button } from "@mui/material";
import {
  CadClickCadBox,
  CadClickCadBoxProps,
  useCadClickUiControlsAppId,
} from "@plansoft-configuration-renderer/components";
import {
  useConfigurationApi,
  useCsAttributes,
  useSessionId,
} from "@plansoft-configuration-renderer/framework";

// const CadClickCadBoxLazy = lazy(() => import("./CadClickCadBox"));

export function CustomCadClickCadBox(props: CadClickCadBoxProps): JSX.Element {
  const api = useConfigurationApi();
  const sessionId = useSessionId();
  const atts = useCsAttributes();

  const [cadTemplate, setCadTemplate] = useState<string>("");
  const appId = useCadClickUiControlsAppId();
  // const Viewer3D = useCadClickViewer3DSingleInstance();

  const CADinstance = appId
    ? //@ts-expect-error: CAD_CLICK_UI_CONTROLS
      window.CAD_CLICK_UI_CONTROLS?.[appId]
    : undefined;
  const viewer3D = CADinstance?.viewer3d[0]?.Viewer3D;

  const handleGetSelectedMeasurement = (): string | null => {
    console.log("appId", appId);
    console.log("attsCadBox", atts);

    const A_UNIT_SYSTEM_ID = atts.find(
      (attributeObj) => attributeObj.id === "A_UNIT_SYSTEM_ID",
    );
    const measuerementsArray = A_UNIT_SYSTEM_ID?.values;
    const selectedMeasurementId: string | undefined = measuerementsArray
      ?.find((msmObj) => msmObj.isSelected === true)
      ?.id?.toLowerCase();
    const measurementMapObj: { [key: string]: string } = {
      si: "mm",
      us: "inch",
    };
    if (selectedMeasurementId && measurementMapObj[selectedMeasurementId]) {
      return measurementMapObj[selectedMeasurementId];
    } else {
      return null;
    }
  };
  const targetMeasurement = handleGetSelectedMeasurement();

  const handleSetMeasurement = (): void => {
    const currentMeasurement = viewer3D?.Options?.scene?.units?.target;

    if (
      targetMeasurement &&
      viewer3D &&
      viewer3D.Options &&
      viewer3D.Options.scene
    ) {
      if (currentMeasurement !== targetMeasurement) {
        viewer3D.Scene.setTargetUnit(targetMeasurement);
      }
    }
  };

  const getCadTemplate = useEffectEvent(async () => {
    try {
      const res = await api.invokeUserDefinedGetter({
        id: sessionId,
        name: "getCadTemplate",
        invokeUserDefinedGetterParams: {
          path: "/XAS_PRODUCT_VIEW/0/",
          input: JSON.stringify({}),
        },
      });

      if (res?.output) {
        setCadTemplate(res.output);
      }
    } catch (error) {
      console.error('Error in invokeUserDefinedGetter "getCadTemplate"', error);
    }
  });

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    getCadTemplate();
  }, []);

  const handleSetMeasurementEffectEvent = useEffectEvent(() => {
    handleSetMeasurement();
  });
  useEffect(() => {
    handleSetMeasurementEffectEvent();
  }, [viewer3D]);

  const memoizedExport = useMemo(
    () => ({
      ...props.exporter,
      pdf3d: {
        layout: cadTemplate,
        zipAllFiles: props.exporter?.pdf3d?.zipAllFiles ?? true,
        zipIfMultipleFiles: props.exporter?.pdf3d?.zipIfMultipleFiles ?? true,
      },
      dimensionalDrawing: {
        layout: cadTemplate,
        zipAllFiles: props.exporter?.dimensionalDrawing?.zipAllFiles ?? true,
        zipIfMultipleFiles:
          props.exporter?.dimensionalDrawing?.zipIfMultipleFiles ?? true,
        // returnStreams: true (library default) opens the file in a data: URL,
        // which browsers block for cookie access → SecurityError. Use false to
        // let the library download via blob/object-URL instead.
        //  returnStreams: false,
        formatsOrder: [
          "PDF",
          "DWG",
          "DXF",
          "PNG",
          "TIFF",
          "SAT",
          "IGES",
          "STEP",
        ],
      },
    }),
    [props.exporter, cadTemplate],
  );

  const memoizedViewer3dSettings = useMemo(
    () => ({
      ...props.viewer3d,
      scene: {
        ...props.viewer3d?.scene,
        units: {
          ...props.viewer3d?.scene?.units,
          base: "mm",
          target: targetMeasurement || "mm",
          floatAccuracy: targetMeasurement === "inch" ? 1 : 0,
        },
      },
    }),
    [props.viewer3d, targetMeasurement],
  );

  if (!cadTemplate) {
    return <></>;
  }
  return (
    <Suspense>
      {/* <CadClickCadBoxLazy {...props} /> */}
      {import.meta.env.DEV ? (
        <Button
          onClick={() => {
            handleSetMeasurement();
          }}
        >
          Unit switch test ({viewer3D?.Options?.scene?.units?.target})
        </Button>
      ) : (
        <></>
      )}

      <CadClickCadBox
        {...props}
        exporter={memoizedExport}
        viewer3d={memoizedViewer3dSettings}
      />
      <CadBoxExportFileName />
    </Suspense>
  );
}
